import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEdit } from 'react-icons/fa';

const AdminEditRestaurant = () => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  // const [ownerId, setOwnerId] = useState('');
  const [email, setEmail] = useState('');

  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const response = await axios.get(
          `/api/admin/restaurants/${restaurantId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        // console.log(response.data);
        setName(response.data.name);
        setAddress(response.data.address);
        // setOwnerId(response.data.owner);
        setEmail(response.data.owner.email);
      } catch (error) {
        console.error('Error fetching restaurant:', error);
      }
    };

    fetchRestaurant();
  }, [restaurantId, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `/api/admin/restaurants/${restaurantId}`,
        { name, address, email },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/admin/restaurants');
    } catch (error) {
      console.error('Error updating restaurant:', error);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8 max-w-[600px]'>
      <h1 className='text-3xl font-bold mb-6 flex items-center'>
        <FaEdit className='mr-3' /> Edit Restaurant
      </h1>
      <form
        onSubmit={handleSubmit}
        className='bg-white p-6 shadow-lg rounded-lg'
      >
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Restaurant Name
          </label>
          <input
            type='text'
            value={name}
            onChange={(e) => setName(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Address
          </label>
          <input
            type='text'
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        {/* <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Owner ID
          </label>
          <input
            type='text'
            value={ownerId}
            onChange={(e) => setOwnerId(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div> */}
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Owner Email
          </label>
          <input
            type='text'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <button
          type='submit'
          className='bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200'
        >
          Update Restaurant
        </button>
      </form>
    </div>
  );
};

export default AdminEditRestaurant;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useParams, useNavigate } from 'react-router-dom';
// import { FaSave } from 'react-icons/fa';

// const AdminEditRestaurant = () => {
//   const { restaurantId } = useParams();
//   const [name, setName] = useState('');
//   const [address, setAddress] = useState('');
//   const [description, setDescription] = useState('');
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem('adminToken');
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchRestaurant = async () => {
//       try {
//         const response = await axios.get(
//           `/api/admin/restaurants/${restaurantId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const { name, address, description } = response.data;
//         setName(name);
//         setAddress(address);
//         setDescription(description);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching restaurant:', error);
//       }
//     };

//     fetchRestaurant();
//   }, [restaurantId, token]);

//   const handleSave = async () => {
//     setLoading(true);
//     try {
//       await axios.put(
//         `/api/admin/restaurants/${restaurantId}`,
//         { name, address, description },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       navigate('/admin/restaurants');
//     } catch (error) {
//       console.error('Error saving restaurant:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Edit Restaurant</h1>
//       <div className='space-y-4'>
//         <div>
//           <label className='block mb-2 font-semibold'>Restaurant Name</label>
//           <input
//             type='text'
//             className='w-full p-3 border rounded'
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder='Enter restaurant name'
//           />
//         </div>
//         <div>
//           <label className='block mb-2 font-semibold'>Address</label>
//           <input
//             type='text'
//             className='w-full p-3 border rounded'
//             value={address}
//             onChange={(e) => setAddress(e.target.value)}
//             placeholder='Enter address'
//           />
//         </div>
//         <div>
//           <label className='block mb-2 font-semibold'>Description</label>
//           <textarea
//             className='w-full p-3 border rounded'
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             placeholder='Enter description'
//           />
//         </div>
//         <button
//           onClick={handleSave}
//           className='inline-block bg-blue-500 text-white py-2 px-4 rounded'
//           disabled={loading}
//         >
//           <FaSave className='mr-2 inline' /> {loading ? 'Saving...' : 'Save'}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AdminEditRestaurant;
